import * as React from 'react';

class ErrorBoundary extends React.Component<{}, {
  hasError: boolean;
  errors: []
}> {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errors: [] };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    /*this.setState({
      errors: this.state.errors.concat([error])
    })*/
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Errors a'plenty!</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/errorboundary/ErrorBoundary.tsx